//Variables to replace
const poolId = 'ap-southeast-2_cEBRbHbs1'
const clientId = '244auub2m35gfp6sah8f5hqvqc'
const api = 'https://qjbo0maer1.execute-api.ap-southeast-2.amazonaws.com/Prod'

const Config = {
    UserPoolId: poolId,
    AppClientId: clientId,
    ApiURL: api + '/notes'
}

export default Config